import './ReviewChangesModal.scss';
import {Modal} from "antd";
import {ToastDeltaUpdate} from "../../generated/dashboard-client";
import ReviewChanges from "./ReviewChanges";

export interface ReviewChangesModalProps {
  onClose: () => void;
  updates: ToastDeltaUpdate[];
  onApprove: (ids: string[]) => void;
}

export function ReviewChangesModal({onClose, updates, onApprove}: ReviewChangesModalProps) {
  return (
    <Modal className={'one changes-modal'} visible={true} onCancel={onClose} closable={true}>
      <ReviewChanges updates={updates} onApprove={onApprove}/>
    </Modal>
  );
}
